import { useEffect, useState } from "react";

export const useTextareaResize = (
  message,
  textareaRef,
  isMobile,
  toolbarMode = null // Optional: pass activeToolId or toolbar state to trigger resize on change
) => {
  const [textareaHeight, setTextareaHeight] = useState(isMobile ? 45 : 40);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    // Reset height to auto to get the correct scrollHeight
    textarea.style.height = "auto";

    // Calculate the line height based on mobile/desktop
    const lineHeight = isMobile ? 20 : 24;
    const maxLines = 9;
    const minHeight = isMobile ? 45 : 40;
    const maxHeight = lineHeight * maxLines;

    // Account for padding in the calculation
    const paddingTop = 4; // py-1 = 4px top padding
    const paddingBottom = isMobile ? 40 : 44; // pb-8 sm:pb-10 + button area
    const totalPadding = paddingTop + paddingBottom;

    // Get the scroll height (content height)
    const scrollHeight = textarea.scrollHeight;

    // Calculate new height including padding
    const contentHeight = scrollHeight - totalPadding;
    const newHeight = Math.max(
      minHeight,
      Math.min(scrollHeight, maxHeight + totalPadding)
    );

    // Apply the new height with smooth transition
    textarea.style.height = `${newHeight}px`;
    textarea.style.transition = "height 0.15s ease-out";

    // Update state for button positioning
    setTextareaHeight(newHeight);

    // If content exceeds max height, enable scrolling
    if (contentHeight > maxHeight) {
      textarea.style.overflowY = "auto";
    } else {
      textarea.style.overflowY = "hidden";
    }
  }, [message, isMobile, textareaRef, toolbarMode]);

  return textareaHeight;
};
